import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { getCountryNames } from 'editor/src/util/calendar/calendarCountries';

import { useIsMobile } from 'editor/src/component/useDetectDeviceType';
import WithTooltip from 'editor/src/component/WithTooltip';

import styles from './index.module.scss';

// Two names still fit on one line of the sidebar; more collapse like the country picker's own label.
const MAX_LISTED_COUNTRIES = 2;

type Props = {
  countries: string[];
};

function EventCountries({ countries }: Props) {
  const { i18n } = useTranslation();
  const isMobile = useIsMobile();
  const language = i18n.languageWithDash ?? 'en';
  const names = useMemo(() => getCountryNames(countries, language), [countries, language]);

  if (names.length <= MAX_LISTED_COUNTRIES) {
    return <div className={styles.eventCountries}>{names.join(', ')}</div>;
  }

  const allNames = [...names].sort((a, b) => a.localeCompare(b, language)).join(', ');
  // On a touch screen the tap that shows the list must not also tick or untick the holiday row.
  const onClick = (e: React.MouseEvent) => {
    if (isMobile) {
      e.stopPropagation();
    }
  };
  return (
    <div className={styles.eventCountries}>
      <WithTooltip overlay={allNames} tappable className="cy-event-countries-more">
        <span onClick={onClick}>{`${names[0]} + ${names.length - 1}`}</span>
      </WithTooltip>
    </div>
  );
}

export default React.memo(EventCountries);
